import { createContext, useReducer } from 'react';
import reducer from '../services/reducer';

export const StoreContext = createContext();

const initialState = {
  notification: {
    notificationText: "",
    open: false,
  },
  loader: {
    visible: false,
  }
}

export default function StoreProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  return <StoreContext.Provider value={[state, dispatch]}>{props.children}</StoreContext.Provider>;
}